import { memo } from 'react'
import { Popconfirm, Button } from 'antd'
import './BasePopconfirm.less'

const BasePopconfirm = ({ disabled, children, className = '', popconfirmProps = {}, buttonProps = {} }: any) => {
  const dom = children ?? (
    <Button disabled={disabled} {...buttonProps} className={`${className} custom_btn`}>
      {buttonProps.label}
    </Button>
  )
  return (
    <>
      {disabled ? (
        dom
      ) : (
        <Popconfirm
          overlayClassName={`${className} BasePopconfirm-container`}
          placement='top'
          trigger='click'
          okText='Yes'
          cancelText='No'
          {...popconfirmProps}
        >
          {dom}
        </Popconfirm>
      )}
    </>
  )
}

export default memo(BasePopconfirm)
